// extracted by mini-css-extract-plugin
export default {"heading":"_22-D0P7hwv","template-info":"dUJpmYP5OH","templateInfo":"dUJpmYP5OH","name":"_3rCFges2x7","info":"_19ARMDSAyr","description":"_38W4Y_y35Z","divider":"c_w4sS__wF","h-rule":"TaUHjBgdQh","hRule":"TaUHjBgdQh","logo":"pjFPfhDZ6d"};
    if(module.hot) {
      // 1630071546940
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  